import $ from "jquery";
import { debounce } from "../utils/functions";

const CLASS_NAVIGATION_MENU_ACTIVE = "navigation-menu--active";

const $window = $(window);
const $body = $("body");
const $header = $(".header");
const $hamburger = $(".header__hamburger");
const $close = $(".navigation-menu__close");
const $navMenu = $(".navigation-menu");
const $navMenuTitle = $(".navigation-menu__title");
const $navMiscLink = $(".navigation-menu-misc__link");
const swipeTreshold = { x: 100, y: 100 };
const data = {
  startMousePos: { x: -1, y: -1 },
  endMousePos: { x: -1, y: -1 },
};

$(function () {
  $window.on("resize:width", debounce(hideNav, true));
  $hamburger.on("click", function (event) {
    event.stopPropagation();
    toggleNav();
  });
  $close.on("click", hideNav);
  $navMenu.on("click", function (event) {
    if ($navMenu.hasClass(CLASS_NAVIGATION_MENU_ACTIVE)) {
      event.stopPropagation();
    }
  });

  let navMenuTitleClick = false;
  $navMenuTitle
    .on("click", function (event) {
      event.stopPropagation();
    })
    .on("mousedown", function () {
      navMenuTitleClick = true;
      toggleMenu($(this));
    })
    .on("focus", function () {
      if (!navMenuTitleClick) {
        showMenu($(this));
      }
      navMenuTitleClick = false;
    });

  $body.on("click", hideNav);
  $navMiscLink.on("click", hideNav);

  //   $body.on("touchstart", function (event) {
  //     onTouchStart(event, data);
  //   });
  //   $body.on("touchend", function (event) {
  //     onTouchEnd(event, data);
  //   });
});

const toggleNav = () => {
  if ($navMenu.hasClass(CLASS_NAVIGATION_MENU_ACTIVE)) {
    hideNav();
  } else {
    showNav();
  }
};

const showNav = () => {
  $navMenu.addClass(CLASS_NAVIGATION_MENU_ACTIVE);
  navOverflow();
  $navMenu.on("scroll", navOverflow);
  $window.on("resize:height.navOverflow", debounce(navOverflow));
};

const hideNav = () => {
  $navMenu.scrollTop(0);
  $navMenu.removeClass(CLASS_NAVIGATION_MENU_ACTIVE);
  $navMenu.off("scroll", navOverflow);
  $window.off("resize:height.navOverflow");
};

const navScrolledTop = () => $navMenu.scrollTop() === 0;
const navScrolledBottom = () =>
  Math.ceil($navMenu.scrollTop() + $navMenu.outerHeight()) >=
  Math.ceil($navMenu[0].scrollHeight);

const navOverflow = () => {
  if (navScrolledTop() && navScrolledBottom()) {
    $navMenu.addClass("menu-is-up menu-is-down");
  } else {
    if (navScrolledTop()) {
      $navMenu.addClass("menu-is-up");
    } else {
      $navMenu.removeClass("menu-is-up");
    }

    if (navScrolledBottom()) {
      $navMenu.addClass("menu-is-down");
    } else {
      $navMenu.removeClass("menu-is-down");
    }
  }
};

// function onTouchStart(event, data) {
//   const evt =
//     typeof event.originalEvent === undefined ? event : event.originalEvent;
//   const touch = evt.touches[0] || evt.changedTouches[0];
//   data.startMousePos.x = touch.pageX;
//   data.startMousePos.y = touch.pageY;
// }

// function onTouchEnd(event, data) {
//   const evt =
//     typeof event.originalEvent === undefined ? event : event.originalEvent;
//   const touch = evt.touches[0] || evt.changedTouches[0];
//   data.endMousePos.x = touch.pageX;
//   data.endMousePos.y = touch.pageY;

//   const mousePosDiff = {
//     x: data.startMousePos.x - data.endMousePos.x,
//     y: data.startMousePos.y - data.endMousePos.y,
//   };

//   data.startMousePos = { x: -1, y: -1 };
//   data.endMousePos = { x: -1, y: -1 };

//   if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
//     if (mousePosDiff.x > 0) {
//       if ($navMenu.hasClass("CLASS_NAVIGATION_MENU_ACTIVE")) {
//         hideNav();
//       }
//     } else {
//       if (
//         $(touch.target).closest(".slider,.project-milestone,.project-info")
//           .length === 0
//       ) {
//         if (!$navMenu.hasClass("CLASS_NAVIGATION_MENU_ACTIVE")) {
//           showNav();
//         }
//       }
//     }
//   }
// }
